import {
  Sheet,
  SheetTitle,
  SheetFooter,
  SheetClose,
  SheetContent,
  SheetHeader,
  SheetDescription,
  SheetTrigger,
} from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { AddressSelector } from 'components/invoices/AddressSelector';
import { useState } from 'react';
import { Invoice } from 'src/trpc';
import { LucidePencil } from 'lucide-react';

export const InvoiceSelectBillingAddressSheet = ({
  isUpdatingInvoice,
  invoice,
  onSelectAddress,
}: {
  isUpdatingInvoice: boolean;
  invoice: Invoice;
  onSelectAddress: (addressId: string) => void;
}) => {
  const [open, setOpen] = useState(false);

  const handleAddressSelect = (addressId: string) => {
    setOpen(false);
    onSelectAddress(addressId);
  };

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button
          size="icon"
          className="absolute top-0 right-0"
          variant="ghost"
          onClick={() => setOpen(true)}
        >
          <LucidePencil className="w-4 h-4" />
        </Button>
      </SheetTrigger>
      <SheetContent className="p-0 sm:max-w-[600px] lg:max-w-[700px] xl:max-w-[800px] h-full">
        <div className="grid h-full grid-rows-[auto_1fr_auto]">
          <SheetHeader className="border-b bg-white px-6 py-4">
            <SheetTitle className="text-left text-lg font-semibold text-gray-900">
              Select Billing Address
            </SheetTitle>
            <SheetDescription className="text-left">
              Choose an existing address for this invoice or create a new one.
            </SheetDescription>
          </SheetHeader>

          <div className="overflow-y-auto px-6 py-6">
            <AddressSelector
              loading={isUpdatingInvoice}
              userId={invoice.userId}
              selectedAddressId={invoice.billingAddressId}
              onAddressSelect={handleAddressSelect}
            />
          </div>

          <SheetFooter className="border-t bg-gray-50 px-6 py-4">
            <div className="flex w-full justify-end gap-4">
              <SheetClose asChild>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => setOpen(false)}
                  disabled={isUpdatingInvoice}
                >
                  Close
                </Button>
              </SheetClose>
            </div>
          </SheetFooter>
        </div>
      </SheetContent>
    </Sheet>
  );
};
